import React, { Component } from 'react'
import { Row, Radio, Input, Spin } from 'antd'
import _ from 'underscore'
import PropTypes from 'prop-types'
import Card from './Card'
import { api, app } from "../app"

const RadioButton = Radio.Button
const RadioGroup = Radio.Group

class TeamSeleted extends Component {
    constructor(props) {
        super(props)
        this.state = {
            teamList: [],
            all_team: [],
            data_load_index: 0,
        }
    }

    async componentDidMount() {
        this._isMounted = true
        await this.teamData()
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    /**
     * 设置值
     * @param data
     * @param cb
     */
    setData = (data) => app.setStateSync(this, data)

    /**
     * 队伍列表
     **/
    teamData = async () => {
        await this.setData({ loading: true })
        let params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { handleData, dataApi } = this.props, { flag, data, msg } = await app.post(dataApi || api.TeamAll, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        } else {
            if (data.length > 0 && handleData) {
                handleData(data[0], 0, data)
            } else {
                handleData({ team_id: '' }, 0, [])
            }
        }
        this.setData({ loading: false, teamList: data, all_team: data })
    }

    /**
     * 搜索
     * @param value
     */
    handleSearch = async (value) => {
        const { all_team } = this.state,
            { handleData } = this.props
        console.log(handleData)
        let teamList = []
        if (value) {
            teamList = _.filter(all_team, (str) => {
                return str.teamname.indexOf(value) !== -1
            })
        } else {
            teamList = all_team
        }
        await this.setData({ teamList })
        if (teamList.length > 0) {
            await this.setData({ data_load_index: 0 })
            const page=1;
            if (handleData) handleData(teamList[0], 0, teamList,page)
        }
    }

    /**
     * 队伍选择
     **/
    handleSelectTeam = async (e) => {
        const { teamList } = this.state, index = parseInt(e.target.value), team = teamList[index], page=1,
            { handleData } = this.props
        this.setData({ data_load_index: index })
        if (handleData) handleData(team, index, teamList,page)
    }

    async componentWillReceiveProps(props) {
        if (props.refresh) {
            await this.teamData()
            await this.setData({ data_load_index: 0 })
            let { refreshLast } = this.props
            if (refreshLast) refreshLast()
        }
    }

    render() {
        let { loading, data_load_index, teamList } = this.state,
            { border } = this.props,
            style = {
                padding: 25,
                height: 'calc(100% - 68px)',
            }
        if (border) {
            style.borderLeft = '1px solid #eee'
            style.borderBottom = '1px solid #eee'
            style.borderRight = '1px solid #eee'
        }
        return (
            <Card width="100%" height="100%" style={style} title={"队伍选择"}>
                {
                    loading ?
                        (<Row className="data-loading" type="flex" align="middle" justify="center"><Spin size="small" /></Row>) :
                        <div style={{ height: '100%' }}>
                            <Input.Search
                                placeholder="输入队伍名搜索"
                                onSearch={this.handleSearch}
                                className="search"
                            />
                            <RadioGroup onChange={this.handleSelectTeam} className="team-list" value={data_load_index}>
                                {
                                    teamList.length > 0 ?
                                        teamList.map((team, index) => {
                                            return (
                                                <RadioButton key={index + 1} className='no-select' value={index}>
                                                    <div title={team.teamname}>{team.teamname}</div>
                                                </RadioButton>
                                            )
                                        }) : (<p style={{ textAlign: "center", padding: "20px 0" }}>无对应队伍</p>)
                                }
                            </RadioGroup>
                        </div>
                }
            </Card>
        )
    }
}

TeamSeleted.propTypes = {
    handleData: PropTypes.func.isRequired,  //数据处理
    refresh: PropTypes.bool,    //是否刷新
    refreshLast: PropTypes.func,    //刷新后
    border: PropTypes.bool, //边框
    dataApi: PropTypes.string, //数据API
}

export default TeamSeleted



// WEBPACK FOOTER //
// ./src/components/TeamSeleted.jsx